export * from './curriculum.enum';